import { connect } from 'react-redux';

import { getTabs } from 'modules/main/selectors';

import Tabs from './Tabs';

export default connect(getTabs)(Tabs);
